
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { EntityControlList } from '@/common/entities/entityControl/EntityControlList';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { McoClaimLineList } from '../mcoClaimLine/mcoClaimLineList';

export const McoClaimDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'claimLines', label: 'Lines', content: <McoClaimLineList mcoClaim={entityObj} /> },
    { id: 'vals', label: 'Validations', content: <ValList parentEntity="MCO_CLAIM" parentEntityId={entityObj.id} /> },
    { id: 'soxControlsTab', label: 'SOX Controls', content: <EntityControlList parentEntity="MCO_CLAIM" parentEntityId={entityObj.id} /> }
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}